import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const fetchSapId = async (data) => {
  try {
    return await postRequest(urls.FETCH_SAPID, data);
  } catch (err) {
    return err;
  }
};
